<template>
  <div class="comp-list-view attention-list" v-loading="loading == -1">

    <list-card :isCanEdit="isCanEdit" :dataList="dataList" @del="del" v-if="dataList.length > 0 && layoutType === 'card'"></list-card>
    <list-table :isCanEdit="isCanEdit" @remarkEdit="remarkEdit" @rowContextmenu="rowContextmenu" :dataList="dataList" @del="del" v-if="dataList.length > 0 && layoutType === 'table'"></list-table>

    <attention-empty @compRecommOpen="$parent.compRecommOpen()" v-if="dataList.length <= 0"></attention-empty>

    <div class="pagination">
      <md-page :page="page" :total="total" :pageSize="pageSize" @pagecallback="pageChanged"></md-page>
    </div>

    <remark-edit ref="remarkEditRefs" @confirm="loadList"></remark-edit>
  </div>
</template>

<script>
import {MessageBox} from 'element-ui';
//引入服务
import {RespurceService,DragService,CommonService,AuthService,UserService} from "@/service";
import {Category,WinForm} from "@/libs";
import Event, {EventEnum} from '@/EventEmeitter'
import {MenuKey} from '@/components/context-menu/key'

import MdPage from '@/components/md-page.vue';
import CardList from "@/components/card-list.vue";
import SvgDrag from '@/components/svg/drag.vue';

import ListCard from './list-card.vue';
import ListTable from './list-table.vue';
import AttentionEmpty from './attention-empty.vue';
import RemarkEdit from './remark-edit.vue';

export default {
  components: { MdPage, SvgDrag, CardList, AttentionEmpty, ListCard, ListTable, RemarkEdit },
  props: {
    treeDirId: { default: 0 },
    listType: { default: '' },
  },
  data() {
    return {
      dataList: [],
      dirId: 0,
      page: 1,
      pageSize: 32,
      total: 0,
      loading: 0, //状态  -1加载中 0 未加载  1 加载完成

      layoutType: 'card',
    };
  },
  watch: {
    treeDirId (value) {
      this.dirId = value;
      this.listType.includes('Enterprise') && (this.loadList(true));
    },
    listType (value) {
      value.includes('Enterprise') && (this.loadList(true));
    },
  },
  computed: {
    // 是否可编辑
    isCanEdit() {
      if (this.listType != 'EnterpriseShare') {
        return true;
      }
      return UserService.user().IsManager;
    }
  },
  mounted() {
    this.getLayout();
  },
  methods: {
    getLayout() {
      let config = WinForm.storge.get(`sjb_config_${AuthService.user().UserID}`) || {};
      this.layoutType = config.layoutCollectComp || 'card';
    },

    async loadList() {
      //加载产品列表
      this.loading = -1;
      RespurceService.search(
        this.page,
        this.pageSize,
        Category[this.listType],
        this.dirId,
      ).then(res => {
        this.total = res.TotalCount;
        res.List.forEach(item => {
          item.DirID = this.dirId;
          item.Exist = true;
        });
        this.dataList = res.List;
        this.loading = 1;
        this.initDrag();
      });
    },
    pageChanged(param) {
      this.page = param.page;
      this.loadList();
    },

    del(row) {
      MessageBox.confirm('您确定要从供应链中删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        CommonService.delete([row.ResID], this.dirId, Category[this.listType], Category.Enterprise).then(res => {
          if (res) {
            if (this.dataList.length == 1 && this.page != 1) {
              this.page--;
            }
            this.loadList();
            this.$parent.dragDataCallback(0, Category[this.listType], this.dirId, Category[this.listType])
          }
        });
      }).catch(() => {
      });
    },

    // 鼠标右键事件
    rowContextmenu(record,event) {
      // 右键菜单
      // Event.emit(
      //   EventEnum.CONTENT_MENU_OPEN,
      //   event.clientX,
      //   event.clientY,
      //   [MenuKey.OPEN, MenuKey.DIVIDER, MenuKey.MOVE_TO, MenuKey.COPY_TO, MenuKey.DELETE],
      //   record,
      //   (menu) => {
      //     console.log(menu)
      //   }
      // );
    },

    initDrag(datas = this.dataList) {
      this.$nextTick(() => {
        DragService.dragToTree({
          table: document.getElementsByClassName('attention-list')[0],
          wrapper: this.layoutType === 'card' ? '.comp-list-con' : 'tbody',
          handle: ".drag-edit",
          delay: 1,
          filter: '.comp-list2',
          primaryKey: "ResID",
          datas,
          category: Category.Enterprise,
          callback: this.dragCallback,
          dirCategory: Category[this.listType],
          operateAreaId: [Category[this.listType], this.listType.includes('Share') ? Category[this.listType.replace('Share', '')] : Category[`${this.listType}Share`]],
        })
      })
    },
    dragCallback(args) {
      this.$parent.dragDataCallback(args.treeId, args.treeDirCategoryId, this.dirId, args.dirCategoryId, args.copy);
      this.loadList();
    },

    // 备注修改
    remarkEdit(row) {
      this.$refs.remarkEditRefs.open(row);
    },
  }
}
</script>

<style lang="less" scoped>

.pagination{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
.comp-list-view{
  display: flex;
  /deep/ .el-empty{
    flex: 1;
  }
}
</style>
